@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
@if (sfrEntity()) {
  <div>
    <div class="toolbar">
      <span>
        <button matButton="text" [disabled]="isBusy()" (click)="backToEntity()">
          <span>
            <mat-icon>keyboard_arrow_left</mat-icon>
            <label>Back</label>
          </span>
        </button>
      </span>
      <span class="spacer"></span>
      <span>
        <label class="sfrWarningLabel">Please Note: SFR Requests take a minimum of 10 business days to complete</label>
      </span>
      <span class="spacer"></span>
      <span>
        @if (!sfrEntity().updatePreventionMessage) {
          <button matButton="text" [disabled]="isBusy() || noChanges()" (click)="save()">
            <span>
              <mat-icon>save</mat-icon>
              <label>Save</label>
            </span>
          </button>
        }
      </span>
    </div>
    @if (errorMessage()) {
      <div class="errorMessage">
        <pre>{{ errorMessage() }}</pre>
      </div>
    }
    <div class="headerInfo">
      <span class="headerGroup">
        <label class="headerLabel">Entity ID</label>
        <input readonly class="headerValue" [value]="sfrEntity().entityKey.entityId"/>
      </span>
      <span class="headerGroup">
        <label class="headerLabel">Project Name</label>
        <input readonly class="headerValue" [value]="sfrEntity().projectName"/>
      </span>
      @if (sfrEntity().statusMessage) {
        <span class="statusGroup">
          {{ sfrEntity().statusMessage }}
        </span>
      }
    </div>
    <div class="content">
      <div class="outlinedContent textEntries">
        <div class="toolbar">
          <span class="spacer"></span>
          <span class="toolbarLabel">SFR Text Entries</span>
          <span class="spacer"></span>
        </div>
        @if (!sfrEntity().updatePreventionMessage) {
          <span>
            <input class="standardTextBox sfrTextEntry" placeholder="Add SFR text entry" [(ngModel)]="sfrAddText"/>
            <button class="standardButton" [disabled]="isBusy() || !sfrAddText" (click)="addTextEntry()">
              <span>
                <mat-icon>add</mat-icon>
                <label class="buttonLabel">Add Entry</label>
              </span>
            </button>
          </span>
        }
        @if (sfrEntity().updatePreventionMessage) {
          <div class="updatePrevention">
            {{ sfrEntity().updatePreventionMessage }}
          </div>
        }
        <div class="tableWithOverflow">
          <table class="reportTable">
            @for (textEntry of sfrEntity().sfrTextEntries; track textEntry) {
              <tr [class.selectedRow]="textEntry === selectedTextEntry"
                (click)="selectTextEntry(textEntry)" class="selectableRow">
                <td class="tableCell">{{ textEntry }}</td>
              </tr>
            }
          </table>
        </div>
      </div>
      @if (filteredLines) {
        <div class="outlinedContent linesGrid">
          <div class="toolbar">
            <span class="spacer"></span>
            <span class="toolbarLabel">{{ getEntityName() }} Lines</span>
            <span class="spacer"></span>
          </div>
          <div class="linesFilter">
            <input class="linesFilterBox standardTextBox" (keyup)="filterSfrLines()" placeholder="Filter lines"
              [(ngModel)]="lineFilter"/>
          </div>
          <div class="tableWithOverflow">
            <table class="reportTable">
              <thead>
                <tr>
                  <td class="tableCell centeredCell headerCell checkboxCell" (click)="toggleAllSelections()"><input
                  type="checkbox" [disabled]="sfrEntity().updatePreventionMessage" [checked]="allItemsSelected()"/></td>
                  <td class="tableCell centeredCell headerCell">Line</td>
                  <td class="tableCell centeredCell headerCell">Product</td>
                  <td class="tableCell centeredCell headerCell">Description</td>
                  <td class="tableCell centeredCell headerCell">Quantity</td>
                  <td class="tableCell centeredCell headerCell">Tags</td>
                </tr>
              </thead>
              @for (line of filteredLines; track line) {
                <tr>
                  <td class="tableCell" (click)="updateTextSelection(line)"><input type="checkbox"
                    [disabled]="sfrEntity().updatePreventionMessage"
                  [checked]="line.selected"/></td>
                  <td class="tableCell centeredCell">{{ line.lineId }}</td>
                  <td class="tableCell">{{ line.productId }}</td>
                  <td class="tableCell">{{ line.description }}</td>
                  <td class="tableCell centeredCell">{{ line.quantity }}</td>
                  <td class="tableCell">{{ line.tags }}</td>
                </tr>
              }
            </table>
          </div>
        </div>
      }
    </div>
  </div>
}

